export default __webpack_public_path__ + "static/media/c3.ae52b16c.png";